export enum ContactType {
  Candidate = 'candidate',
  Reference = 'reference',
  Prospect = 'prospect'
}
